var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.chatJoined", {
            agent: _vm.getActorName(),
            visitor: _vm.maskedPayloadFullname,
          })
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }